import { render, staticRenderFns } from "./Forums.vue?vue&type=template&id=69cb6726&scoped=true"
import script from "./Forums.vue?vue&type=script&lang=js"
export * from "./Forums.vue?vue&type=script&lang=js"
import style0 from "./Forums.vue?vue&type=style&index=0&id=69cb6726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cb6726",
  null
  
)

export default component.exports